<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeSucursales',
    componentOptions: {
        title: 'RastreabilidadeSucursales',
        actions: [
            [
                {
                    name: 'RastreabilidadeSucursales',
                    showView: false,
                    action: 'abrirRastreabilidade',
                    route: 'RastreabilidadeSucursales',
                    nameTranslationKey: 'mensagens.menuLateral.rastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirRastreabilidade() {
            if (this.$route.name !== 'RastreabilidadeSucursales') {
                this.$router.push({
                    name: 'RastreabilidadeSucursales'
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
